import { render, staticRenderFns } from "./admin-manufacturerModal.vue?vue&type=template&id=4e43bd64&"
import script from "./admin-manufacturerModal.vue?vue&type=script&lang=js&"
export * from "./admin-manufacturerModal.vue?vue&type=script&lang=js&"
import style0 from "./admin-manufacturerModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports